module.exports = __webpack_public_path__ + "static-portal/img/banner5.5caa9df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner5.jpg
// module id = rBYr
// module chunks = 4